module.exports = __webpack_public_path__ + "img/step-5.05d633d2.png";